import { render, staticRenderFns } from "./TemplateCardMenu.vue?vue&type=template&id=1d4f2fa0&scoped=true"
import script from "./TemplateCardMenu.vue?vue&type=script&lang=js"
export * from "./TemplateCardMenu.vue?vue&type=script&lang=js"
import style0 from "./TemplateCardMenu.vue?vue&type=style&index=0&id=1d4f2fa0&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4f2fa0",
  null
  
)

export default component.exports